import LogoUploadSection from "../common/LogoUploadSection";
import { useLogoUpload } from "../common/useLogoUpload";

const LOGO_CONFIGS = [
  {
    label: "Home Team Logo",
    fileNameKey: "homeTeamFileName",
    dispatchType: "setLineupHomeTeamLogo",
    logoType: "homeTeamLogo",
  },
  {
    label: "Away Team Logo",
    fileNameKey: "awayTeamFileName",
    dispatchType: "setLineupAwayTeamLogo",
    logoType: "awayTeamLogo",
  },
];

const LineupLogosSection = () => {
  const { cardInfo, addFile, removeFile } = useLogoUpload(LOGO_CONFIGS, "lineup");

  return (
    <div className="mt-2">
      {LOGO_CONFIGS.map(({ label, dispatchType, logoType }) => (
        <LogoUploadSection
          key={logoType}
          label={label}
          logo={cardInfo[logoType]}
          onFileAdd={(file) => addFile(dispatchType, logoType, file)}
          onFileDelete={() => removeFile(dispatchType, logoType)}
        />
      ))}
    </div>
  );
};

export default LineupLogosSection;
